import { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { MeshProps } from '@react-three/fiber'
import { cover } from '../../../../../utility/constant/helper.constant'
import { Helper, LogBar } from '../../../../../classes/helper'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import { useMontage } from '../../../../../context/montage.context'
import { useSelectedValueByVariableKey } from '@k3/core'

interface Props extends MeshProps {
  isBackLog?: boolean
}

export const LogsBarModel = ({ position, isBackLog }: Props): JSX.Element => {
  const { measure, roof, typ } = useMontage()

  const group: any = useRef()
  const { nodes } = useGLTF(
    `model/support/logBarSupport.glb`
  ) as GLTF & any

  // const demoColor = roof.supportForm === 'softline' ? 'blue' : roof.userColor

  const scaleY = LogBar.scale(measure, isBackLog!)
  const width = typ?.width ?? 0
  const depth = typ?.depth ?? 0

  return (
    <group
      ref={group}
      dispose={null}
      position={position}
      scale={[
        Helper.convertToMeter(width / 2),
        Helper.convertToMeter(scaleY),
        Helper.convertToMeter(depth / 2),
      ]}
      castShadow={cover.terraceCover.castShadow}
    >
      <mesh
        geometry={nodes['LogBarSupport'].geometry}
        castShadow={cover.terraceCover.castShadow}
        receiveShadow={true}
      >
        <meshPhysicalMaterial color={roof.userColor} />
      </mesh>
    </group>
  )
}
